/**
 * Shared localStorage key for support undelivered count.
 * Used by Next.js landing and React profile app - both must use same key.
 *
 * When user reads support messages in React profile app, call:
 *   clearSupportUndelivered()
 * or
 *   localStorage.removeItem('nextship_support_undelivered_count')
 *
 * This keeps the yellow dot in sync - if user reads in profile, dot disappears on Next.
 */
export const SUPPORT_UNDELIVERED_KEY = 'nextship_support_undelivered_count'

export const clearSupportUndelivered = () => {
  try {
    localStorage.removeItem(SUPPORT_UNDELIVERED_KEY)
  } catch {
    // ignore
  }
}

export const getPersistedUndeliveredCount = () => {
  try {
    const saved = localStorage.getItem(SUPPORT_UNDELIVERED_KEY)
    if (saved === null) return null
    const count = parseInt(saved, 10)
    return Number.isNaN(count) ? null : count
  } catch {
    return null
  }
}

export const persistUndeliveredCount = (count) => {
  try {
    if (count != null && count > 0) {
      localStorage.setItem(SUPPORT_UNDELIVERED_KEY, String(count))
    } else {
      clearSupportUndelivered()
    }
  } catch {
    // ignore
  }
}
